module.exports = __webpack_public_path__ + "img/Truce_White.98908801.png";